import {Directive, HostListener} from '@angular/core';

@Directive({
  selector: '[cmsStopClickPropagation]',
})
export class StopClickPropagationDirective {
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    event.stopPropagation();
  }
}
